import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@clerk/react";
import { toast } from "sonner";
import { errMsg, useApi } from "@/lib/api";

export const useCheckout = () => {
  const { isSignedIn, isLoaded } = useAuth();
  const api = useApi();
  const navigate = useNavigate();
  const [busy, setBusy] = useState("");

  const checkout = async (plan, extra = {}) => {
    if (!isLoaded) return;
    if (!isSignedIn) {
      const back = `/upgrade?plan=${plan}${extra.seats ? `&seats=${extra.seats}` : ""}`;
      return navigate(`/sign-up?redirect_url=${encodeURIComponent(back)}`);
    }
    setBusy(plan);
    try {
      const { data } = await api.post("/billing/checkout", { plan, origin_url: window.location.origin, ...extra });
      window.location.href = data.checkout_url;
    } catch (e) {
      toast.error(errMsg(e, "Couldn't start checkout"));
      setBusy("");
    }
  };
  return { checkout, busy, ready: isLoaded };
};
